import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { PricingSection } from './components/PricingSection';
import { ModuleSection } from './components/ModuleSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { CostSection } from './components/CostSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
export function App() {
  return <div className="min-h-full w-full bg-ink font-sans" data-id="element-0" data-mp="2wi5pxq64f1t0">
      <Hero data-id="element-1" data-mp="28t4j27cxrypu" />
      <main data-id="element-2" data-mp="28sl48zil1qg1">
        <ProblemSection data-id="element-3" data-mp="28sbend1g9lav" />
        <TomosSection data-id="element-4" data-mp="23vkuoemiy5k6" />
        <BonosSection data-id="element-5" data-mp="23u9t8lgjx9w8" />
        <PricingSection data-id="element-6" data-mp="23utb6267bya9" />
        <ModuleSection data-id="element-7" data-mp="23ti864kkyuk7" />
        <TestimonialsSection data-id="element-8" data-mp="3ik7k0rkruvvx" />
        <GuaranteeSection data-id="element-9" data-mp="3ij652c0mxp8x" />
        <FaqSection data-id="element-10" data-mp="3ijpef4c7z5bc" />
        <CostSection data-id="element-11" data-mp="3mljat0fdtn5p" />
        <FinalCta data-id="element-12" data-mp="3ml12h5fg3ihf" />
      </main>
      <Footer data-id="element-13" data-mp="3mk83wrqn3zad" />
      <PurchaseToast data-id="element-14" data-mp="3mjq3rk0ux0x6" />
    </div>;
}